import ExcelJS from "exceljs";
import dayjs from "dayjs";
import { saveAs } from "file-saver";

const generateLoanApplicationAuditExcel = (data, selectedDate, endDate) => {
  const branches = {};
  const loanTypesSet = new Set();
  const monthsSet = new Set();

  data.forEach((item) => {
    const { branchId, branchName, loanType, month, approvedCount, rejectedCount } = item;

    if (!branches[branchId]) {
      branches[branchId] = {
        branchName,
        loans: {}
      };
    }

    if (!branches[branchId].loans[loanType]) {
      branches[branchId].loans[loanType] = {};
    }

    branches[branchId].loans[loanType][month] = {
      approved: approvedCount,
      rejected: rejectedCount,
      collection: approvedCount + rejectedCount,
    };

    loanTypesSet.add(loanType);
    monthsSet.add(month);
  });

  const loanTypes = [...loanTypesSet];
  const months = [...monthsSet].sort();
  const branchList = Object.values(branches);

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Loan Application Report");

  const formattedStart = dayjs(selectedDate).format("YYYY/MM/DD");
  const formattedEnd = dayjs(endDate).format("YYYY/MM/DD");

  const titleText = `Loan Application Report ${formattedStart} - ${formattedEnd}`;

  const columnsPerBranch = months.length * 3;
  const totalColumns = 1 + (columnsPerBranch * branchList.length);

  ws.mergeCells(1, 1, 1, totalColumns);
  ws.getCell("A1").value = titleText;
  ws.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
  ws.getRow(1).font = { bold: true, size: 16 };

  let colIndex = 2;

  branchList.forEach((branch) => {
    const startCol = colIndex;
    const endCol = colIndex + (months.length * 3) - 1;

    ws.mergeCells(3, startCol, 3, endCol);
    ws.getCell(3, startCol).value = branch.branchName;
    ws.getCell(3, startCol).font = { bold: true, size: 12 };
    ws.getCell(3, startCol).alignment = { horizontal: "center" };

    months.forEach((month) => {
      ws.getCell(4, colIndex).value = `${dayjs(month).format("MMM")} Approved`;
      ws.getCell(4, colIndex + 1).value = `${dayjs(month).format("MMM")} Rejected`;
      ws.getCell(4, colIndex + 2).value = `${dayjs(month).format("MMM")} Collection`;

      ws.getCell(4, colIndex).font = { size: 10 };
      ws.getCell(4, colIndex + 1).font = { size: 10 };
      ws.getCell(4, colIndex + 2).font = { size: 10 };

      colIndex += 3;
    });
  });

  ws.getCell(4, 1).value = "Loan Name";
  ws.getCell(4, 1).font = { size: 10 };

  let rowStart = 5;

  loanTypes.forEach((loan) => {
    ws.getCell(rowStart, 1).value = loan;
    ws.getCell(rowStart, 1).font = { size: 10 };

    let col = 2;

    branchList.forEach((branch) => {
      months.forEach((month) => {
        const d = branch.loans[loan]?.[month] || {
          approved: 0,
          rejected: 0,
          collection: 0,
        };

        ws.getCell(rowStart, col).value = d.approved;
        ws.getCell(rowStart, col + 1).value = d.rejected;
        ws.getCell(rowStart, col + 2).value = d.collection;

        ws.getCell(rowStart, col).font = { size: 10 };
        ws.getCell(rowStart, col + 1).font = { size: 10 };
        ws.getCell(rowStart, col + 2).font = { size: 10 };

        col += 3;
      });
    });

    rowStart++;
  });

  ws.eachRow({ includeEmpty: false }, (row) => {
    row.eachCell({ includeEmpty: false }, (cell) => {
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  ws.columns.forEach((col) => {
    col.width = 16;
  });

  wb.xlsx.writeBuffer().then((buffer) => {
    saveAs(new Blob([buffer]), `Loan_Application_Report.xlsx`);
  });
};

export default generateLoanApplicationAuditExcel;
